import React, { useState, cloneElement } from 'react';

const DefaultContent = ({ showCloseButton, closeModal }) => {
  return (
    <div className="relative bg-white text-center p-12 rounded-t-2xl transition-transform duration-300 sm:rounded-2xl sm:mx-auto sm:w-full sm:max-w-lg">
      {showCloseButton && (
        <button
          onClick={closeModal}
          className="absolute top-4 right-4 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700 transition"
          title="Close"
        >
          ×
        </button>
      )}
      <img
        src="/api/placeholder/150/150"
        alt="Trophy"
        className="w-[150px] h-[150px] mx-auto mb-3 sm:w-[170px] sm:h-[170px]"
      />
      <h1 className="text-2xl text-gray-800 font-medium mb-2">Good Job!</h1>
      <p className="text-gray-600 mb-6">Click the button to close</p>
      <button className="w-[90%] bg-gray-800 hover:bg-gray-900 text-white px-5 py-4 rounded-lg transition-colors duration-300">
        View status
      </button>
    </div>
  );
};

const CustomModal = ({blurbg, defaultOpen = true, showCloseButton = false, Content = DefaultContent,additionClass="" }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const closeModal = () => setIsOpen(false);

  return (
    <section className="grid place-items-center mx-4">
      <div
        className={`fixed ${additionClass} inset-0 ${blurbg===undefined?"bg-gray-600/80":blurbg} grid items-end overflow-hidden transition-all duration-300 z-50 ${
          isOpen ? 'visible opacity-100' : 'invisible opacity-0'
        }`}
      >
        {/* Check if Content is a React element or a component */}
        {typeof Content === 'object'
          ? cloneElement(Content, { showCloseButton, closeModal }) // Clone object and pass props
          : <Content showCloseButton={showCloseButton} closeModal={closeModal}/> // Pass props directly to functional component
        }
      </div>
    </section>
  );
};

export default CustomModal;
